"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const utils_1 = require("./utils");
const Selection = react_1.memo((props) => {
    return utils_1.createHTMLBox({ strokeWidth: 1, ...props });
});
exports.default = Selection;
//# sourceMappingURL=Selection.js.map